/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary → Text`)
};

const es_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario → Texto`)
};

const de_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binär → Text`)
};

const nl_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary → Text`)
};

const fr_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaire → Texte`)
};

const it_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario → Testo`)
};

const pt_br2_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário → Texto`)
};

const pt_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário → Texto`)
};

const ja_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary → Text`)
};

const zh_tb_mode_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary → Text`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_mode_decode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_mode_decode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_mode_decode", locale)
	if (locale === "en") return en_tb_mode_decode(inputs)
	if (locale === "es") return es_tb_mode_decode(inputs)
	if (locale === "de") return de_tb_mode_decode(inputs)
	if (locale === "nl") return nl_tb_mode_decode(inputs)
	if (locale === "fr") return fr_tb_mode_decode(inputs)
	if (locale === "it") return it_tb_mode_decode(inputs)
	if (locale === "pt-BR") return pt_br2_tb_mode_decode(inputs)
	if (locale === "pt") return pt_tb_mode_decode(inputs)
	if (locale === "ja") return ja_tb_mode_decode(inputs)
	return zh_tb_mode_decode(inputs)
};